import React from 'react';
import { useState } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Avatar, Divider} from '@material-ui/core';

import modules from './modules'; // All the parent knows is that it has modules ...

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
}));

function App() {
  const [currentTab, setCurrentTab] = useState('Home');
  const classes = useStyles();

  return (
    <Router basename={'/tools/watermelonwilt'}>
      <Redirect to="/home"/>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <ul id="home-menu">
                <li>
                  <a href="http://agroclimate.org" rel="noopener noreferrer">
                    <Avatar id="menu-img" alt="logo" src="/tools/watermelonwilt/agroclimate.jpg"/>
                  </a>
                </li>
                {modules.map(module => ( // with a name, and routes
                  <li key={module.name} className={currentTab === module.name ? 'active' : ''}>
                    <Link to={module.routeProps.path} onClick={() => setCurrentTab(module.name)}>{module.name}</Link>
                  </li>
                ))}
              </ul>
              <Divider/>
                <h1>Watermelon Wilt risk calculator</h1>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <div className="App-content">
                  {modules.map(module => (
                    <Route {...module.routeProps} key={module.name} />
                  ))}
                </div>
              </Grid>
            </Grid>
          </div>
        </Router>
  );
}

export default App;
